import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { cn } from "@omni/utils/styles";

import { Compare } from "@/components/Product/ECommerce/components/compare/compare.component";

type ComparisonProps = {
    product: Product<ProductFieldSet.ProductTile>;
    className?: string;
};

const Comparison = ({ product, className }: ComparisonProps) => {
    return (
        <Compare
            className={cn(className)}
            product={product}
        />
    );
};

export { Comparison };
